import { render, staticRenderFns } from "./moveFiles.vue?vue&type=template&id=5dbc9b22&scoped=true"
import script from "./moveFiles.vue?vue&type=script&lang=js"
export * from "./moveFiles.vue?vue&type=script&lang=js"
import style0 from "./moveFiles.vue?vue&type=style&index=0&id=5dbc9b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbc9b22",
  null
  
)

export default component.exports